/**
 * QA Environment Configuration
 * 
 * Used when building with: ng build --configuration=qa
 * Angular's file replacement mechanism will replace environment.ts
 * with this file during the qa build process.
 */

import { buildPasswordResetUrl } from './environment.common';

const APP_ORIGIN = 'https://ledger.qa.elodt.com';

export const environment = {
  production: false,
  envName: 'QA',
  appVersion: '0.0.2-qa',
  // Use Firebase Hosting rewrite (/api/**) to keep same-origin requests.
  apiBaseUrl: '/api',
  appUrl: APP_ORIGIN,
  passwordResetUrl: buildPasswordResetUrl(APP_ORIGIN),
  supabaseUrl: 'https://hluyrytotjulncspotgr.supabase.co',
  supabaseAnonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhsdXlyeXRvdGp1bG5jc3BvdGdyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODkxMzkyODUsImV4cCI6MjEwNDcxNTI4NX0.2gMdLMkyo9K8KYpDWVY7JAcH3vRgrkta9Ben7RAYsBU',
  allowPublicRegistrationFallback: false,
};

